// extracted by mini-css-extract-plugin
export default {"buttons":"vp_VOAE3","mainButton":"vp_tN0eA","extraButton":"vp_urvzv"};